import { render, staticRenderFns } from "./AgesTable.vue?vue&type=template&id=537b5a9f&scoped=true"
import script from "./AgesTable.vue?vue&type=script&lang=js"
export * from "./AgesTable.vue?vue&type=script&lang=js"
import style0 from "./AgesTable.vue?vue&type=style&index=0&id=537b5a9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b5a9f",
  null
  
)

export default component.exports